import { OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

export abstract class AbstractLoading implements OnInit {

    public isLoading: boolean;

    public mensagem: string;

    constructor() {
    }

    ngOnInit() {
        this.carregarDados();
    }

    carregarDados() {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;
        this.mensagem = null;

        this.getServico()
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                    this.finalizar();
                })
            ).subscribe((dados: any) => {
                this.preencherDados(dados);
            }, (error) => {
                // console.log(error);

                this.isLoading = false;
                this.mensagem = error.message;
            });
    }

    abstract getServico(): Observable<any>;

    abstract preencherDados(dados: any): void;

    finalizar() {

    }

}
